import React, { Component, PropTypes } from 'react'
import { Button, Select, Row, Col } from 'antd'
import { connect } from 'react-redux'
import { getAllUsers } from '../../action/user/getall'
import { getProcesseDefinitionList } from '../../action/workflow/process'

const Option = Select.Option

class FilterRow extends Component {
  constructor(props) {
    super(props)
    const { processDefinitionKey } = props.initValues
    this.state = {
      processDefinitionKey,
      uid: ''
    }
  }
  static defaultProps = {
    allUsers: [],
    isUid: true,
    initValues: {
      processDefinitionKey: '0',
      uid: ''
    }
  }

  componentWillMount() {
    this.props.getAllUsers()
    this.props.getProcesseDefinitionList();
  }

  processDefinitionKeyChangeHandle = (value) => {
    this.setState({ processDefinitionKey: value }, () => this.searchHandle())
  }
  uidChangeHandle = (value, option) => {
    if (!value) value = ''
    this.setState({ uid: value }, () => this.searchHandle())
  }
  searchHandle = () => {
    if (typeof this.props.changeHandle === 'function') {
      this.props.changeHandle(this.state)
    }
  }
  getValues = () => {
    return this.state
  }

  render() {
    const { allUsers, isUid, processDefinitions } = this.props
    const processDef = [];
    for (let key in processDefinitions) {
      processDef.push({
        id: key,
        name: processDefinitions[key]
      })
    }
    return (
      <div className="table-head">
        <Row gutter={20}>
          <Col span={6}>
            <div className="flex-input-w">
              <div className="label">流程类型: </div>
              <Select
                allowClear
                style={{ flexBasis: 250, flexGrow: 0 }}
                placeholder="选择流程类型"
                value={this.state.processDefinitionKey}
                onChange={this.processDefinitionKeyChangeHandle}
              >
                <Option value={'0'} key={0}>全部类型</Option>
                {
                  processDef.map(item => {
                    return (
                      <Option value={item.id.toString()} key={item.id.toString()}>{item.name}</Option>
                    )
                  })
                }
              </Select>
            </div>
          </Col>

          {
            isUid && (
              <Col span={6}>
                <div className="flex-input-w">
                  <div className="label">发起人: </div>
                  <Select
                    showSearch
                    allowClear
                    style={{ flexBasis: 250, flexGrow: 0 }}
                    placeholder="选择发起人"
                    optionFilterProp="children"
                    onChange={this.uidChangeHandle}
                    filterOption={(input, option) => {
                      return option.props.children.join('').toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }}
                  >
                    {
                      allUsers.map((item) => {
                        return <Option value={item.uid + ''} key={item.uid}>{item.realName} | {item.email}</Option>
                      })
                    }
                  </Select>
                </div>
              </Col>
            )
          }
          {/* <Col span={2}>
            <Button type="primary" icon="search" onClick={() => this.searchHandle()}>搜索</Button>
          </Col> */}
        </Row>
      </div>
    )
  }
}

const mapStateToProps = ({ page }) => {
  const {
		allUsers,
    definitions: processDefinitions
	} = page
  return {
    allUsers,
    processDefinitions
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAllUsers: () => dispatch(getAllUsers()),
    getProcesseDefinitionList: () => dispatch(getProcesseDefinitionList())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterRow)



// WEBPACK FOOTER //
// ./src/components/workflow/filterRow.js